import { createAsyncThunk } from '@reduxjs/toolkit'
import { getCrashGameReportService, getDiceGameReportService } from 'network/services/game.service'
import { DEFAULT_GAME_ID } from 'utils/constants/index'

export const fetchCrashGameReport = createAsyncThunk(
  'fetch/crashGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getCrashGameReportService({ gameId: DEFAULT_GAME_ID.CRASH, ...data })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchDiceGameReport = createAsyncThunk(
  'fetch/diceGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getDiceGameReportService({ gameId: DEFAULT_GAME_ID.DICE, ...data })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
